import { Component } from '@angular/core';
import { InvoiceHeader } from 'app/model/entities/entity-model';
import { DialogBaseComponent, DialogParams } from 'app/shared/dialog-base.component';
import { DomainService } from 'app/shared/domain.service';
import { UtilFns } from 'app/shared/util-fns';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface FreightExplanationDialogParams extends DialogParams {
  invoiceHeader: InvoiceHeader;
}

@Component({
  templateUrl: './freight-explanation-dialog.component.html',
  standalone: false,
})
export class FreightExplanationDialogComponent extends DialogBaseComponent<FreightExplanationDialogParams> {
  invoiceHeader!: InvoiceHeader;

  // Calculated values for display
  invoiceId!: string;
  shipmentId: number | undefined;
  isFirstShipmentInvoice!: boolean;
  isPrimaryInvoice!: boolean;
  doesAccountPayFreight!: boolean;
  shouldChargeFreightOnFirstShipmentOnly!: boolean;
  hasThirdPartyCarrier!: boolean;
  carrierAccountName!: string | undefined;
  totalShipmentFreight!: number;
  actualChargedFreight!: number;
  relatedInvoices: { id: string; subtotal: number; isFirstShipment: boolean }[] = [];
  explanationText!: string;
  allFirstShipment!: boolean;

  constructor(
    public config: DynamicDialogConfig<FreightExplanationDialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService,
  ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: 'Freight Calculation Explanation',
      width: '700px',
      height: 'auto',
    });

    this.prepare();
  }

  async prepare() {
    this.invoiceHeader = this.params.invoiceHeader;

    // Extract all the relevant values
    this.invoiceId = this.invoiceHeader.id;
    this.shipmentId = this.invoiceHeader.shipmentId;
    this.isFirstShipmentInvoice = this.invoiceHeader.isFirstShipmentInvoice;
    this.isPrimaryInvoice = this.invoiceHeader.isPrimaryInvoice;
    this.doesAccountPayFreight = this.invoiceHeader.joHeader?.doesAccountPayFreight !== false;
    this.shouldChargeFreightOnFirstShipmentOnly = this.invoiceHeader.joHeader?.shouldChargeFreightOnFirstShipmentOnly === true;
    this.hasThirdPartyCarrier = !!this.invoiceHeader.joHeader?.carrierAccountNumber;
    this.carrierAccountName = this.invoiceHeader.joHeader?.carrierAccountName;
    this.totalShipmentFreight = this.invoiceHeader.shipment?.freightAmt ?? 0;
    this.actualChargedFreight = this.invoiceHeader.calcShipFreightAmt();

    // Build the list of related invoices in this shipment
    const shipmentInvoices = this.invoiceHeader.shipment?.invoiceHeaders ?? [];
    this.relatedInvoices = shipmentInvoices.map((inv) => ({
      id: inv.id,
      subtotal: inv.subtotalAmt ?? 0,
      isFirstShipment: inv.isFirstShipmentInvoice,
    }));

    // Check if all invoices are first shipment (-01) invoices
    this.allFirstShipment = shipmentInvoices.every((inv) => inv.isFirstShipmentInvoice);

    // Get the explanation text from the entity
    this.explanationText = this.invoiceHeader.shipFreightInfo;

    this.isPageReady = true;
  }

  formatCurrency(value: number): string {
    return UtilFns.fmtCurrency(value);
  }

  close() {
    this.dialogRef.close();
  }
}
